<template>
  <div id="app">
<!--    <div v-if="this.customGlobal.userInfo.authed!='success'">-->
<!--      {{ parentTitle }}-->
<!--      <router-view/>-->
<!--    </div>-->
<!--    <div v-else>-->
<!--      {{ customGlobal.userInfo.username +"登录时间:"+ customGlobal.getFormatDateTimeString(2)}}-->
<!--      <router-view/>-->
<!--    </div>-->
<!--    <keep-alive>-->
<!--    <router-view v-if="isRouterAlive" />-->
    <router-view  />
<!--    </keep-alive>-->
  </div>
</template>
<script>
export default {
  name: 'App',

  // provide() {
  //   return {
  //     reload: this.reload
  //   }
  // },

  data:function(){
    return{
      // isRouterAlive: true,
      parentTitle:'父组件区域',
      userInfo: this.customGlobal.userInfo
    }

  },
  mounted:function(){
    //console.info("APP.vue mounted get route params :"+ JSON.stringify(this.$route.params));
  },
  destroyed() {

  },
  created: function() {
    this.userInfo= this.customGlobal.userInfo
    //console.info('APP.vue created userInfo:'+JSON.stringify(this.userInfo));

  },
  beforeRouteEnter (to, from, next) {//路由进入前
    //console.info("App组件进入前to:"+JSON.stringify(to)+",from:"+from+",next:"+  next );
    next();
  },
  methods: {

    //重载
    // reload () {
    //   this.isRouterAlive = false
    //   this.$nextTick(function () {
    //     this.isRouterAlive = true
    //   });
    // }
  },
  components: {
  }
}
</script>

<style>
/*.el-scrollbar__wrap {*/
/*  overflow-x: hidden !important;*/
/*  overflow-y: hidden !important;*/
/*}*/
/*.el-menu:not(.el-menu--collapse) {*/
/*  width: 200px !important;*/
/*  min-height: 200px !important;*/
/*}*/

html,body,#app{
  height: 100%;
  padding:0px;
  margin:0px;
  font-family: 'MiSans-Regular', sans-serif;
}
#app {
  font-family: 'MiSans-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.el-select-dropdown__list {
  margin-bottom: 15px !important;
}
.el-cascader-menu__list{
  margin-bottom: 15px !important;
  overflow-x: hidden !important;
}
.el-cascader__suggestion-list {
  margin-bottom: 15px !important;
  overflow-x: hidden !important;
}

/*自定义*/
.test-5 {
  overflow-y: auto;
  table-layout: fixed;
  word-wrap: break-word;
  word-break: break-all;
}
.test-5::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.test-5::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
  rgba(255, 255, 255, 0.2) 25%,
  transparent 25%,
  transparent 50%,
  rgba(255, 255, 255, 0.2) 50%,
  rgba(255, 255, 255, 0.2) 75%,
  transparent 75%,
  transparent);
}
.test-5::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  /* background : ; */
  border-radius: 10px;
}
.el-input__inner,
.el-textarea__inner {
  font-family: inherit; /* 继承父元素字体 */
}

</style>



// WEBPACK FOOTER //
// src/App.vue